<!-- Read-only agent list of the run review: name, Vermittler-Id, Abrechnungskonto (link or explicit absence). -->
<div class="flex flex-column gap-2">
    @for (agent of agents; track agent.agentId) {
        <div class="flex align-items-center justify-content-between flex-wrap gap-2 surface-ground border-round p-2">
            <div class="flex flex-column">
                <span class="font-medium text-900">{{ agent.agentName || 'Unbekannter Vermittler' }}</span>
                <span class="text-sm text-600">Vermittler-Id {{ agent.agentId }}</span>
            </div>
            @if (agent.provisionAgentId) {
                <div class="flex align-items-center gap-2">
                    @if (!agent.provisionAgentActive) {
                        <p-tag value="Konto nicht aktiv" severity="warn"></p-tag>
                    }
                    <p-button label="Abrechnungskonto öffnen"
                              icon="fa-regular fa-arrow-up-right-from-square"
                              severity="secondary"
                              [text]="true"
                              size="small"
                              (onClick)="openAccount(agent)">
                    </p-button>
                </div>
            } @else {
                <p-tag value="Kein Abrechnungskonto" severity="danger"></p-tag>
            }
        </div>
    } @empty {
        <span class="text-600 text-sm">{{ emptyText }}</span>
    }
</div>
